var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddcoin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0922 18.5455C13.0922 19.1484 12.6042 19.6364 12.0012 19.6364C11.3983 19.6364 10.9103 19.1484 10.9103 18.5455V17.2472C10.3141 17.0362 9.77928 16.6727 9.38473 16.1474C9.02255 15.6658 9.11841 14.9818 9.59993 14.6196C10.0772 14.2596 10.7633 14.3512 11.1276 14.8348C11.7029 15.5998 13.0922 15.1289 13.0922 14.1818C13.0922 13.5799 12.6021 13.0909 12.0012 13.0909C10.1966 13.0909 8.72852 11.6228 8.72852 9.81819C8.72852 8.39783 9.64328 7.19819 10.9103 6.74641V5.45456C10.9103 4.85158 11.3983 4.36365 12.0012 4.36365C12.6042 4.36365 13.0922 4.85158 13.0922 5.45456V6.75281C13.6884 6.96387 14.2232 7.32728 14.6178 7.85267C14.9799 8.33419 14.8841 9.01819 14.4026 9.38037C13.9252 9.74045 13.2413 9.64779 12.8748 9.16517C12.666 8.88706 12.3464 8.72728 12.0012 8.72728C11.4004 8.72728 10.9103 9.2163 10.9103 9.81819C10.9103 10.4201 11.4004 10.9091 12.0012 10.9091C13.8059 10.9091 15.274 12.3772 15.274 14.1818C15.274 15.6022 14.3592 16.8018 13.0922 17.2536V18.5455Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 12,
    y1: 24,
    x2: 12,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AA6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 12.0012,
    y1: 19.6364,
    x2: 12.0012,
    y2: 4.36365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddcoin);
export default __webpack_public_path__ + "static/media/addcoin.97a23fe80c0365264a1bb8485b3113a7.svg";
export { ForwardRef as ReactComponent };